/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type appEconomic_viewer = {
    readonly id: string;
    readonly company: {
        readonly id: string;
        readonly economicEnabled: boolean | null;
    } | null;
    readonly " $refType": "appEconomic_viewer";
};
export type appEconomic_viewer$data = appEconomic_viewer;
export type appEconomic_viewer$key = {
    readonly " $data"?: appEconomic_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"appEconomic_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appEconomic_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "economicEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
(node as any).hash = 'a4025ea5d7b88f9725c5289139913851';
export default node;
